import { environment } from '../../../enviroments/enviroment';
import { AESUtil } from '../adapters/crypto-adapter';

const setItem = <T>(key: string, plainText: T): string => {
  const cipherText = AESUtil.encrypted(
    JSON.stringify(plainText),
    environment.key,
    environment.iv
  );
  sessionStorage.setItem(key, cipherText);
  return cipherText;
};

const getItem = <T>(key: string): T | null => {
  const value = sessionStorage.getItem(key);
  if (!value) {
    return null;
  }
  const plainText = AESUtil.decrypted(value, environment.key, environment.iv);
  return JSON.parse(plainText);
};

const clear = (): void => {
  sessionStorage.clear();
};

const removeItem = (key: string): void => {
  sessionStorage.removeItem(key);
};

export const KeyStorageUtil = {
  setItem,
  getItem,
  clear,
  removeItem,
};
